<mat-drawer-container class="h-full" hasBackdrop="false">
  <mat-drawer opened mode="side" disableClose>
    <div class="h-full flex flex-col">
      <mat-toolbar class="shrink-0" *appHasPermission="'client_event:create'">
        <button mat-flat-button class="w-full" (click)="handleEventCreate()">
          <mat-icon>add</mat-icon>

          Maken
        </button>
      </mat-toolbar>
      <div class="flex-auto px-2 pb-4 overflow-auto scrollbar-width-thin">
        <mat-calendar
          class="overflow-hidden min-h-76"
          [class]="{
            '-mt-1.5': isReadOnly,
          }"
        />

        <app-scheduler-legend />

        <app-client-editor-list [items]="renderedClientEditors()" />
      </div>
    </div>
  </mat-drawer>

  <mat-drawer
    #secondaryDrawer
    mode="over"
    position="end"
    autoFocus="false"
    class="border-l! border-gray-200!"
  >
    <div class="h-full flex flex-col">
      <mat-toolbar class="shrink-0">
        <h3 class="text-lg! font-medium! flex-auto">
          Conflicten <span class="text-gray-500">({{ eventConflicts().length }})</span>
        </h3>

        <button class="inline-flex!" mat-icon-button (click)="secondaryDrawer.close()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-toolbar>

      <mat-divider class="mx-4! [--mat-divider-color:var(--color-gray-200)]" />

      <div class="py-4 flex-auto overflow-auto scrollbar-width-thin">
        <div class="px-4 flex flex-col gap-2">
          @for (conflict of eventConflicts(); track $index) {
            <div
              class="bg-white rounded-lg p-4 hover:bg-gray-100 hover:cursor-pointer transition-colors"
              (click)="gotoConflict(conflict); secondaryDrawer.close()"
              role="presentation"
            >
              <div class="text-sm font-medium truncate">{{ conflict.label }}</div>
              <div class="text-xs text-gray-500">
                {{ conflict.startDate | date: 'd MMM yyyy HH:mm' }} &ndash;
                {{ conflict.endDate | date: 'HH:mm' }}
              </div>
              <div
                class="inline-flex py-1 px-2 rounded-full text-xs font-medium mt-2"
                [class]="
                  conflict.conflictType === 'overlap'
                    ? 'bg-red-100 text-red-800'
                    : 'bg-amber-100 text-amber-800'
                "
              >
                {{ conflict.conflictType === 'overlap' ? 'Overlap' : 'Te kort' }}
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </mat-drawer>

  <mat-drawer-content class="transition-none!">
    <div class="flex flex-col h-full">
      <mat-toolbar class="shrink-0">
        <div class="flex items-center gap-4 flex-auto">
          <button
            mat-stroked-button
            [matTooltip]="now | date: 'MMMM d, yyyy' | titlecase"
            (click)="today()"
          >
            Vandaag
          </button>

          <div class="flex items-center">
            <button
              class="[--mdc-icon-button-state-layer-size:32px]"
              mat-icon-button
              (click)="previous()"
              matTooltip="Vorige"
            >
              <mat-icon>keyboard_arrow_left</mat-icon>
            </button>
            <button
              class="[--mdc-icon-button-state-layer-size:32px]"
              mat-icon-button
              (click)="next()"
              matTooltip="Volgende"
            >
              <mat-icon>keyboard_arrow_right</mat-icon>
            </button>
          </div>

          <span class="font-medium">{{ calendarTitle() | titlecase }}</span>
        </div>

        <div class="flex items-center gap-2">
          <button
            mat-stroked-button
            [matMenuTriggerFor]="copyMenu"
            *appHasPermission="'client_event:create'"
          >
            <mat-icon>content_copy</mat-icon>
            Kopiëren
            <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
          </button>

          <mat-menu #copyMenu="matMenu">
            <button mat-menu-item id="copy-day-btn" (click)="handleCopyDay()">
              <mat-icon>today</mat-icon>
              Dag kopiëren
            </button>

            <button mat-menu-item id="copy-week-btn" (click)="handleCopyWeek()">
              <mat-icon>date_range</mat-icon>
              Week kopiëren
            </button>
          </mat-menu>

          <button mat-stroked-button [matMenuTriggerFor]="calendarViewMenu">
            {{ calendarViewSelected() | mapFrom: calendarViewMap }}

            <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
          </button>

          @if (eventConflicts().length) {
            <button
              class="inline-flex!"
              mat-icon-button
              (click)="secondaryDrawer.open()"
            >
              <mat-icon>warning</mat-icon>
            </button>
          }
        </div>

        <mat-menu #calendarViewMenu="matMenu">
          @for (
            view of calendarViewMap | keyvalue: sortCalendarViewOptions;
            track $index
          ) {
            <button mat-menu-item (click)="setCalendarView(view.key)">
              {{ view.value }}
            </button>
          }
        </mat-menu>
      </mat-toolbar>

      <div class="p-4 pt-0 flex-auto overflow-auto">
        <full-calendar class="bg-white h-full" [options]="calendarOptions()" />
      </div>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
